import { motion } from "framer-motion";

export const Container = ({ children, className = "" }) => (
  <div className={`max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 ${className}`}>{children}</div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`rc-eyebrow ${className}`}>{children}</span>
);

export const Section = ({ id, children, className = "", alt = false }) => (
  <section
    id={id}
    className={`relative py-20 md:py-32 ${alt ? "bg-rc-bg2" : "bg-rc-bg"} ${className}`}
  >
    {children}
  </section>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Em = ({ children }) => (
  <em className="font-serif italic not-italic text-rc-sage" style={{ fontStyle: "italic" }}>
    {children}
  </em>
);
